import React, { useContext } from 'react'
import DotsPopover from '@Components/DotsPopover'
import { UserMaintenanceActions } from '@Components/UserRowComponent/user-maintenance-actions'
import { Link } from 'react-router'
import Navigation from '@App/navigation'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

interface UserActivityBlockProps {
    noDots?: boolean
    onOpenConfirmPopup: (userAction: UserMaintenanceActions) => void
    lastActivityDateString: string
    exposedUserId?: string
}

const UserActivityBlock = (props: UserActivityBlockProps) => {
    const { rightsholderStore } = useContext<RootStore>(StoresContext)

    const { noDots, onOpenConfirmPopup, lastActivityDateString, exposedUserId } = props

    const currentRightsholderId = rightsholderStore.currentRightsholderId

    return (
        <div className="user-activity">
            {lastActivityDateString && (
                <p className="last-activity">
                    Last Activity: <b>{lastActivityDateString}</b>
                </p>
            )}
            {!noDots && (
                <DotsPopover>
                    <p onClick={() => onOpenConfirmPopup(UserMaintenanceActions.resentInvite)}>Resend Invite</p>
                    <p onClick={() => onOpenConfirmPopup(UserMaintenanceActions.removeUser)} className="delete">
                        Remove User
                    </p>
                </DotsPopover>
            )}
            {!!exposedUserId && (
                <Link
                    to={Navigation.rightholder.maintenance.userPermissionsProfile(currentRightsholderId, exposedUserId)}
                    className="link bold"
                >
                    View
                </Link>
            )}
        </div>
    )
}

export default observer(UserActivityBlock)
